export class ResetPasswordModel {
    email: string;
    password: string;
    confirmPassword: string;
    code: string;

    constructor(email: string,
        password: string,
        confirmPassword: string,
        code: string) {
            this.email = email;
            this.password= password;
            this.confirmPassword= confirmPassword;
            this.code= code;
        }
}